import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AuthState {
  token: string | null
  username: string | null
  setAuth: (token: string, username: string) => void
  clearAuth: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      username: null,
      setAuth: (token, username) => set({ token, username }),
      clearAuth: () => set({ token: null, username: null }),
    }),
    { name: 'lm-admin-auth' }
  )
)

export function getAdminToken(): string | null {
  try {
    const raw = localStorage.getItem('lm-admin-auth')
    if (!raw) return null
    return (JSON.parse(raw) as { state?: { token?: string } })?.state?.token ?? null
  } catch {
    return null
  }
}
